module.exports = __webpack_public_path__ + "img/21CreekRdLot6HabitatPlan20100810.38bd59ec.png";